import {Component, OnInit} from '@angular/core';
import {FormGroup, FormControl, Validators} from "@angular/forms";
import {CustomValidators} from "ng2-validation";
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import {fadeInOutTranslate} from '../../shared/elements/animation';
import { Router } from'@angular/router';
import { AngularFireDatabase, FirebaseListObservable , FirebaseObjectObservable} from "angularfire2/database-deprecated";
import { NgbCalendar } from "@ng-bootstrap/ng-bootstrap";
import { Upload } from '../../uploads/shared/upload';
import * as _ from "lodash";
import { UserService } from '../shared/user.service';
import { LogisticsService } from 'app/logistics-operations/shared/logistics.service';
import { DateService } from 'app/date/date.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { DriverService } from '../drivers/shared/driver.service';
import { Driver } from 'selenium-webdriver/chrome';
export const search_id = {
  id: ""
};

@Component({
  selector: 'app-supervisors',
  templateUrl: './supervisors.component.html',
  styleUrls: ['./supervisors.component.css'],
  animations: [fadeInOutTranslate],
  providers:[AngularFireDatabase, DriverService, NotificationToastService, LogisticsService, DateService]
})
export class SupervisorsComponent implements OnInit {

  switchDisable: boolean = true;
  names: string = '';
  email: String='';
  password: String='';
  myForm: FormGroup;
  drivers: FirebaseListObservable<any[]>;
  user: Observable<firebase.User>;
  authenticated: boolean = false;
  id: string = '';
  myFormEdit: FormGroup;
  admindata : FirebaseObjectObservable<any>;

  selectedPic: FileList;
  selectedProfilePic: FileList;
  selectedDLFront: FileList;
  selectedDLBack: FileList;

  currentUploadDL: Upload;
  currentUploadProfilePic: Upload;
  currentUploadDLFront: Upload;
  currentUploadDLBack: Upload;

  image: String = './app/assets/images/placeholder.jpg';
  profilePic: String;
  uploadData: Upload;

  hasFile: Boolean = false;
  hasProfilePic: Boolean = false;
  hasDLFront: Boolean = false;
  hasDLBack: Boolean = false;

  private basePath:string = '/uploads';
  private subPath:string = '/profileImages';

  public sortOrder: string = "desc";
  public sortBy: string = "";
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  
  position: string = 'bottom-right';
  title: string;
  msg: string;
  showClose: boolean = true;
  timeout: number = 5000;
  theme: string = 'bootstrap';
  type: string = 'default';
  closeOther: boolean = false;

  branches:any;
  branchList: any;
  branchArray:any;

  private imageToUpload1 = "assets/images/avatar-4.png";
  private imageToUpload2 = "assets/images/idfront.png";
  private imageToUpload3 = "assets/images/idback.png";

  constructor(public af: AngularFireAuth, public db:AngularFireDatabase,private router: Router, public calendar: NgbCalendar,private dateService: DateService, private driverService: DriverService, private nf: NotificationToastService, private userService:UserService, private logisticsService: LogisticsService) {
    this.initializeForm();
    /*Basic validation end*/
    this.drivers = db.list('/users');
    this.myForm.reset();
    this.myForm.controls["code"].setValue('+966');
  }
  
  ngOnInit() {
    this.image = "assets/images/avatar-4.png";
    this.getAllDriver();
    this.getAllBranchData();

  this.checkSearchId();
  //this.getAllBranch();
    }
    initializeForm()
    {
      let name = new FormControl('', Validators.required);
      let username = new FormControl('', Validators.required);
      let code = new FormControl('', [Validators.required]);
      let phone = new FormControl('', [Validators.required]);
      let address = new FormControl('', Validators.required);
      let email = new FormControl('', [Validators.required, Validators.email]);
      let password = new FormControl('', Validators.required);
      let dlFront = new FormControl('', Validators.required);
      let dlBack = new FormControl('', Validators.required);
      let rpassword = new FormControl('', [Validators.required,CustomValidators.equalTo(password)]);
      let branch = new FormControl('Select Branch', Validators.required);
      this.myForm = new FormGroup({
        name:name,
        username: username,
        code: code,
        phone: phone,
        address: address,
        email: email,
        password: password,
        rpassword: rpassword,
        dlFront: dlFront,
        dlBack: dlBack,
        branch: branch
      });
    }
    getAllDriver()
    {
      var x = this.driverService.getSupervisors();
      if(localStorage.getItem("courierapp_role") == "super admin")
      {
        x.snapshotChanges().subscribe(item=>{
          this.data = [];
          item.forEach(element =>{
            var y = element.payload.toJSON();
              y["$key"] = element.key;
              this.data.push(y as Driver);
          });
        });
      }
      else
      {
        x.snapshotChanges().subscribe(item=>{
          this.data = [];
          item.forEach(element =>{
            var y = element.payload.toJSON();
            if(element.payload.child("branch").val() == localStorage.getItem("branch"))
            {
              y["$key"] = element.key;
              this.data.push(y as Driver);
            }
          });
        });
      }
    }
    getAllBranchData()
    {
      var branch = this.userService.getAllBranches();
      branch.snapshotChanges().subscribe(item=>{
        this.branches = [];
        this.branchList = [];
        item.forEach(element =>{
          var y = element.payload.toJSON();
            y["$key"] = element.key;
            this.branches.push(y);
            this.branchList[element.key] = element.payload.toJSON();
        });
      });
    }
    checkSearchId()
    {
      if(search_id.id != "")
      {
        this.filterQuery = search_id.id;
      }
    }
    submitted: boolean;
    error: String = '';
    hasError: boolean = false;
    phone_error:boolean = false;
    onSubmit() {
      this.hasError = false;
      this.submitted = true;
      if(this.hasProfilePic)
      //console.log(this.selectedProfilePic.item(0));
      if(this.hasDLFront)
      //console.log(this.selectedDLFront.item(0));
      if(this.hasDLBack)
      //console.log(this.selectedDLBack.item(0));
      
      this.phone_error = false;
      var phone = this.myForm.value.phone;
      if(phone.length != this.maxLength){
        this.phone_error = true;
        return;
      }
      else if(this.myForm.valid) {
        if(this.hasProfilePic && this.hasDLFront && this.hasDLFront)
        {
          this.currentUploadProfilePic = new Upload(this.selectedProfilePic.item(0));
          this.currentUploadDLFront = new Upload(this.selectedDLFront.item(0));
          this.currentUploadDLBack = new Upload(this.selectedDLBack.item(0));
          firebase.database().ref("users").orderByChild("userName").equalTo(this.myForm.value.username).once("value",(snapshot)=>{
            if(snapshot.numChildren() > 0)
            {
              alert("user name exists");
            }
            else
            {
              this.createUser(this.myForm.value.email,this.myForm.value.password,this.currentUploadProfilePic,this.currentUploadDLFront,this.currentUploadDLBack);
            }
          });
        }
        else if(this.hasDLFront && this.hasDLFront)
        {
          this.currentUploadDLFront = new Upload(this.selectedDLFront.item(0));
          this.currentUploadDLBack = new Upload(this.selectedDLBack.item(0));
          firebase.database().ref("users").orderByChild("userName").equalTo(this.myForm.value.username).once("value",(snapshot)=>{
            if(snapshot.numChildren() > 0)
            {
              alert("user name exists");
            }
            else
            {
              this.createUser(this.myForm.value.email,this.myForm.value.password,null,this.currentUploadDLFront,this.currentUploadDLBack);
            }
          });
        }
        else
        {
          if(this.hasDLFront)
          {
            //dl front required
          }
          else
          {
            //dl back required

          }
        }
      } 
    }
    public createUser(email:string,password:string,currentUpload1:Upload,currentUpload2:Upload,currentUpload3:Upload)
    {
      firebase.database().ref("users").orderByChild("phoneNumber").equalTo(this.myForm.value.phone).once("value",(snapshot)=>{
        if(snapshot.numChildren() > 0)
        {
          alert("phone number exists");
        }
        else
        {
          this.af.auth.createUserWithEmailAndPassword(email,password)
        .then(
        (success) => {
            var userId = this.af.auth.currentUser.uid;
            if(this.hasProfilePic)
            {
              this.uploadAll(userId,currentUpload1,currentUpload2,currentUpload3);
            }
            else{
              this.uploadDlFront(userId,currentUpload2,currentUpload3);
            }           
              
        })
        .catch(
        (err) => {
            //console.log(err);
            this.hasError = true;
            this.error = err;
        });
        }
      });
    }

    openMyModal(event) {
      document.querySelector("#" + event).classList.add('md-show');
    }
  
    closeMyModal(event) {
      ((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
    }
 
  onChange(event, id) {
    //console.log(event);
    if(event)
    {
      //console.log("this is active");
      this.drivers.update(id,{ 
        status: "1"
      }).then(
        (success) => {
          //console.log("status updated");
        });
    }
    else{
      //console.log("this is inactive");
      this.drivers.update(id,{ 
        status: "0"
      }).then(
        (success) => {
          //console.log("status updated");
        });
    }
  }

  detectFiles(event,type) {
    this.selectedPic = event.target.files;
    if(this.selectedPic.length!=0)
    {
      switch(type)
      {
          case "p" : 
          this.selectedProfilePic = this.selectedPic;
          this.myForm.setControl("profile",new FormControl(this.selectedProfilePic));
          this.hasProfilePic = true;
          //this.hasFile = true;
          this.readUrl(event,type);
          break;
          case "dlf" : 
          this.selectedDLFront = this.selectedPic;
          this.myForm.setControl("dlFront",new FormControl(this.selectedDLFront, Validators.required));
          this.hasDLFront = true;
          this.readUrl(event,type);
          break;
          case "dlb" : 
          this.selectedDLBack = this.selectedPic;
          this.myForm.setControl("dlBack",new FormControl(this.selectedDLBack, Validators.required));
          this.hasDLBack = true;
          this.readUrl(event,type);
          break;
      }
    }
}
imageToUpload: any;
readUrl(event:any,type:string) {
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();

    reader.onload = (event:any) => {
      switch(type)
        {
          case "p" : 
          this.imageToUpload1 = event.target.result;
          break;
          case "dlf" : 
          this.imageToUpload2 = event.target.result;
          break;
          case "dlb" : 
          this.imageToUpload3 = event.target.result;
          break;
        }
    }
    reader.readAsDataURL(event.target.files[0]);
  }
}
    private saveFileData(userId) {
      var date_time =  this.dateService.getTimeandDate();
      if(this.hasProfilePic && this.hasDLFront && this.hasDLBack)
      {
        var usersRef = firebase.database().ref("users");
          usersRef.child(userId).set({ 
            name: this.myForm.value.name,
            userName: this.myForm.value.username,
            code: this.myForm.value.code,
            phoneNumber: this.myForm.value.phone,
            role: "supervisor",
            address: this.myForm.value.address,
            email: this.myForm.value.email,
            imageUrl: this.currentUploadProfilePic.url,
            idFrontUrl: this.currentUploadDLFront.url,
            idBackUrl: this.currentUploadDLBack.url,
            branch:this.myForm.value.branch,
            status: "1",
            createdAt: date_time.date,
            createdTime: date_time.time
          }).then(
            (success) => {
              //console.log("success creation");
              this.myForm.reset();
              this.myForm.controls["code"].setValue('+966');
              this.submitted = false;
              this.currentUploadProfilePic = null;
              this.currentUploadDLFront = null;
              this.currentUploadDLBack = null;
              this.hasFile = false;
              this.image = "assets/images/avatar-4.png";
              this.hasProfilePic = false;
              this.hasDLFront = false;
              this.hasDLBack = false;
              this.imageToUpload1 = "assets/images/avatar-4.png";
              this.imageToUpload2 = "assets/images/idback.png";
              this.imageToUpload3 = "assets/images/idback-4.png";
              this.nf.addToast({title:'Registration Success', msg:'New Driver has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
            });
      }
      else if(this.hasDLFront && this.hasDLBack)
      {
        var usersRef = firebase.database().ref("users");
          usersRef.child(userId).set({ 
            name: this.myForm.value.name,
            userName: this.myForm.value.username,
            code: this.myForm.value.code,
            phoneNumber: this.myForm.value.phone,
            role: "supervisor",
            address: this.myForm.value.address,
            email: this.myForm.value.email,
            photo: null,
            idFrontUrl: this.currentUploadDLFront.url,
            idBackUrl: this.currentUploadDLBack.url,
            branch:this.myForm.value.branch,
            status: "1",
            createdAt: date_time.date,
            createdTime: date_time.time
          }).then(
            (success) => {
              //console.log("success creation");
              this.myForm.reset();
              this.myForm.controls["code"].setValue('+966');
              this.submitted = false;
              this.currentUploadProfilePic = null;
              this.currentUploadDLFront = null;
              this.currentUploadDLBack = null;
              this.hasProfilePic = false;
              this.hasDLFront = false;
              this.hasDLBack = false;
              this.imageToUpload1 = "assets/images/avatar-4.png";
              this.imageToUpload2 = "assets/images/idfront.png";
              this.imageToUpload3 = "assets/images/idback.png";
              this.image = "assets/images/avatar-4.png";
              this.nf.addToast({title:'Registration Success', msg:'New Driver has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
              event.preventDefault();
            });
        }
      }

func(type)
{
  //console.log("cancel selection");
    switch(type)
    {
      case "p" : 
      this.hasProfilePic = false;
      this.imageToUpload1 = "assets/images/avatar-4.png";
      this.selectedProfilePic = null;
      break;
      case "dlf" : 
      this.hasDLFront = false;
      this.imageToUpload2 = "assets/images/idfront.png";
      this.selectedDLFront = null;
      break;
      case "dlb" : 
      this.hasDLBack = false;
      this.imageToUpload3 = "assets/images/idback.png";
      this.selectedDLBack = null;
      break;
    }
}
refresh()
    {
      //console.log("refresh");
      this.sortBy = "";
      this.filterQuery = "";
    }

    viewDetails(id)
    {
      search_id.id = this.filterQuery;
      this.router.navigate(['/manage-supervisor'], { queryParams : {key: id, from: 'supervisor'}  });
    }


    uploadAll(userId:string,currentUpload1: Upload, currentUpload2 : Upload,currentUpload3:Upload)
    {
      if(this.hasProfilePic)
      {
        
      let storageRef = firebase.storage().ref();
      let uploadTask1 = storageRef.child(`${this.basePath}/${this.subPath}/${userId}`).put(currentUpload1.file);
      uploadTask1.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) =>  {
          this.currentUploadProfilePic.progress = (uploadTask1.snapshot.bytesTransferred / uploadTask1.snapshot.totalBytes) * 100
        },
        (error) => {
          //console.log(error)
        },
        () => {
          this.nf.addToast({title:'Uploaded', msg:'Profile upload Success', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
          this.currentUploadProfilePic.url = uploadTask1.snapshot.downloadURL
          this.currentUploadProfilePic.name = this.currentUploadProfilePic.file.name
          this.uploadDlFront(userId,currentUpload2,currentUpload3);
        }
      );
     
      }
    }
    uploadDlFront(userId,currentUpload2,currentUpload3)
    {
      if(this.hasDLFront)
      {
      let path="/idFront";
      let storageRef = firebase.storage().ref();
      let uploadTask1 = storageRef.child(`${this.basePath}/${path}/${userId}`).put(currentUpload2.file);
      uploadTask1.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) =>  {
          this.currentUploadDLFront.progress = (uploadTask1.snapshot.bytesTransferred / uploadTask1.snapshot.totalBytes) * 100
        },
        (error) => {
          //console.log(error)
        },
        () => {
          this.nf.addToast({title:'Uploaded', msg:'Id front upload Success', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
          this.currentUploadDLFront.url = uploadTask1.snapshot.downloadURL
          this.currentUploadDLFront.name = this.currentUploadDLFront.file.name
          this.uploadDlBack(userId,currentUpload3);
        }
      );
     
      }
    }
    uploadDlBack(userId,currentUpload3)
    {
      if(this.hasDLFront)
      {
      let path="/idBack";
      let storageRef = firebase.storage().ref();
      let uploadTask1 = storageRef.child(`${this.basePath}/${path}/${userId}`).put(currentUpload3.file);
      uploadTask1.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) =>  {
          this.currentUploadDLBack.progress = (uploadTask1.snapshot.bytesTransferred / uploadTask1.snapshot.totalBytes) * 100
        },
        (error) => {
          //console.log(error)
        },
        () => {
          this.nf.addToast({title:'Uploaded', msg:'Id back upload Success', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
          this.currentUploadDLBack.url = uploadTask1.snapshot.downloadURL
          this.currentUploadDLBack.name = this.currentUploadDLBack.file.name
          this.saveFileData(userId);
        }
      );
     
      }
    }
  keyPressUserName(event)
  {
    var format = /[a-zA-Z0-9-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !format.test(inputChar)) {
      event.preventDefault();
    }
  }
  maxLength: number =9;
  onChangeCountry(e)
  {
    //console.log(e.target.value);
    this.phone_error = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength  = 10;
      this.myForm.controls["phone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      //console.log(this.maxLength);
      break;
      case "+966" : this.maxLength  = 9;
      this.myForm.controls["phone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      //console.log(this.maxLength);
      break;
    }
  }
  keyPress(event: any) {
    this.phone_error = false;
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone = this.myForm.value.phone;
      if(phone.length >= this.maxLength)
      {
        event.preventDefault();
      }
    }
  }
  getAllBranch()
  {
    var drivers= this.logisticsService.getBranch();
    drivers.snapshotChanges().subscribe(item=>{
      this.branchList = [];
      this.branchArray = [];
      item.forEach(element =>{
        var data = element.payload.toJSON();
        data["$key"] = element.key;
        this.branchList.push(data);
        this.branchArray[element.key] = data;
        
      });
      //console.log("branchList", this.branchList,this.branchArray);
    });
  }
  isChangeBranch: boolean = false;
  selectedBranch:any;
  changeBranch(shipmentId)
  {
    this.isChangeBranch = true;
    this.rowIdBranch = shipmentId;
  }
  getSelectedBranch(e)
  {
    this.selectedBranch = e.target.value;
    //console.log("selectedBranch", this.selectedBranch);
  }
  rowIdBranch:any;
  assignToBranch(userId)
  {
    //console.log("userId", userId);
    if(this.selectedBranch != null)
    {
      firebase.database().ref("users").child(userId).child("branch").set(this.selectedBranch).then(()=>{
        this.selectedBranch = null;
        this.isChangeBranch = false;
        this.rowIdBranch = null;
      });
    }
      else
      {
        this.rowIdBranch = null;
        this.isChangeBranch = false;
      }
  }  

}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/users/supervisors/supervisors.component.ts